export enum OrientationError {
  NoError = 'NoError',
  DisplayInLandscapeModeButScreenIsPortrait = 'DisplayInLandscapeModeButScreenIsPortrait',
  DisplayInPortraitModeButScreenIsLandscape = 'DisplayInPortraitModeButScreenIsLandscape'
}
